var tprice = document.getElementById("ship-price").value;
   console.log(tprice)
// Calculate the progress number, and the width of the progress bar.
function calculateProgress(currentVal, targetVal) {
  var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
  var progressNum = document.querySelectorAll('.cart-shipping__num');
  var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
  var successMsg = document.querySelectorAll('.cart-shipping__success');
  console.log(progressBar+progressNum+progressOuter+successMsg)
  // calculate how far progress is from the total as a percentage
  var result = Math.round(100 * currentVal / targetVal);
  progressBar.forEach(function(el){
    el.setAttribute('style', "width: ".concat(result, "%"));
    if ( result > 100 ){
      result = 100;
    }
    else
    {
      result = result;
    }
    console.log(result)
    el.innerHTML = result+"%";
  })
   // Update the progess text. If threshold is met, show success message
  var newProgressNum = (targetVal - currentVal) / 100;
  if(newProgressNum <= 0){
    successMsg.forEach(function(el){
      el.style.display = 'block';
    });
    progressOuter.forEach(function(el){
      el.style.display = 'none';
    });
    progressNum.forEach(function(el){
      el.textContent = newProgressNum;
    });
  } else {
    successMsg.forEach(function(el){
      el.style.display = 'none';
    });
    progressOuter.forEach(function(el){
      el.style.display = 'block';
    });
    progressNum.forEach(function(el){
      el.textContent = newProgressNum;
    });
  }
};

// In your theme's main JS file, find each ajax call where your store adds to, deletes from, and updates the cart. Put this in the success function of each. 
// NOTE: If you make this ajax request outside of the functions that update the cart, the calculator won't sync with the current cart state without refreshing the page. You need to specify that you want to read the current cart data AFTER the new items are added/removed.
 fetch('/cart.js')
.then(response => response.json())
.then(data => {
  calculateProgress(data.total_price, 5000);
});
$(document).ready(function(){
  var maxHeight = 0, maxHeightElement = null;
$('ul#product-grid li.grid__item').each(function(){
  console.log($(this).find("h3.card__heading.h5").height())
   if ($(this).find("h3.card__heading.h5").height() > maxHeight) {
       maxHeight = $(this).find("h3.card__heading.h5").height();
       maxHeightElement = $(this).find("h3.card__heading.h5");
   }
});
  console.log(maxHeight)
  if ( $(window).width() > 900 )
  {
    $('ul#product-grid li.grid__item').find("h3.card__heading.h5").height(maxHeight)
  }
  
})
